<template>
    <div class="form-group" :class="{'row':vertical}">
        <div class="col-form-label" :class="{'col-lg-3':vertical, 'padding-top-zero':!vertical}">
            <label v-if="label">{{label}}</label>
        </div>
        <div :class="{'col-lg-9':vertical}">
            <div class="input-group">
                <span class="input-group-prepend">
                    <span class="input-group-text"><i class="icon-calendar22"></i></span>
                </span>
                <input type="text" class="form-control" ref="datePicker">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SingleDatePicker",
        props: {
            label: {
                type: String,
            },
            vertical: {
                type: Boolean,
                default: false
            },
            value: {
            },
        },
        mounted() {
            let vue = this
            let datePicker = this.$refs.datePicker
            $(datePicker).daterangepicker({
                // applyClass: 'btn-small btn-primary',
                // cancelClass: 'btn-light',
                autoApply: true,
                autoUpdateInput: true,
                buttonClasses: ['btn btn-default'],
                singleDatePicker: true,
                // timePicker: true,
                // timePickerIncrement: 10,
                locale: {
                    format: 'DD/MM/YYYY'
                }
            },(start,label)=>{
                $(datePicker).val(start.format('DD/MM/YYYY'));
                vue.$emit('input',start.valueOf())
            })
            vue.$emit('input',this.$moment($(datePicker).val(),'DD/MM/YYYY').valueOf())
        },
    }
</script>

<style scoped>
    .padding-top-zero {
        padding-top:0px !important;
    }
    .daterangepicker .applyBtn {
        display: block !important;
    }
</style>
